<h3 mat-dialog-title>Confirmation!</h3>
<mat-dialog-content class="pb-0">
  <h5 class="py-4">{{data.message}}</h5>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="button-primary me-2" mat-dialog-close>No</button>
  <button class="button-primary white" (click)="confirmed()"><span>Yes</span></button>
</mat-dialog-actions>